
const doubleRegExp = /^[+-]?\d*(\.\d*)?$/

export const isValidDouble = (value: string) => doubleRegExp.test(value)